export const ResponsiveLineChartMeta = {
    scenarios: {
    },

    testids: {
        line: "",
    }
};